import React from "react";

export default function One() {
  return (
    <div className="die-face first-face">
      <span className="dot"></span>
    </div>
  );
}
